var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBackgroundWaves = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1500 800"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "section-0",
  d: "M458.99 800H0V537.624C182.838 472.248 427.048 568.84 458.99 800Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "section-1",
  d: "M819.079 800H458.99C427.049 568.838 182.838 472.247 0 537.623V263.81q26.052 6.317 52.155 12.02c397.857 87.074 854.447 125.293 783.805 459.699q-7.202 34.085-16.881 64.47Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "section-2",
  d: "M1206.744 800H819.079q9.624-30.37 16.881-64.471C906.602 401.123 450.012 362.904 52.155 275.83Q26.078 270.128 0 263.81V0h258.956c96.023 190.815 340.67 334.97 716.819 526.954C1099.546 590.126 1171.128 686.59 1206.744 800Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "section-3",
  d: "M1466.264 800h-259.52c-35.616-113.412-107.198-209.874-230.97-273.046C599.626 334.97 354.98 190.814 258.957 0h679.135c178.336 52.725 333.426 152.348 360.687 418.977 17.991 176.01 80.159 301.525 167.486 381.022Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "section-4",
  d: "M1500 800h-33.736c-87.327-79.498-149.495-205.013-167.486-381.023C1271.517 152.347 1116.427 52.725 938.09 0h207.271c81.253 149.904 212.209 241.634 354.638 263.084Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "section-5",
  d: "M1500 263.084C1357.57 241.634 1226.615 149.904 1145.362 0H1500Z"
})));

export default SvgBackgroundWaves;